import { toTypedSchema } from '@vee-validate/zod';
import { useForm } from 'vee-validate';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { z } from 'zod';
import { formatBirthDateInput, parseBirthDate, toApiBirthDate, validateBirthDate } from '@/helpers/profile-birth-date';
import { actionTypes } from '@/store/modules/profile/createProfile';
import { DEFAULT_PROFILE_AVATAR } from '@/views/profiles/constants';

export const useAddProfileForm = () => {
  const { t } = useI18n();
  const store = useStore();
  const router = useRouter();

  const requiredMessage = t('addProfileForm.errors.required');

  const validationSchema = toTypedSchema(
    z.object({
      name: z.string({ required_error: requiredMessage }).trim().min(1, requiredMessage),
      dateOfBirth: z
        .string({ required_error: requiredMessage })
        .min(1, requiredMessage)
        .superRefine((value, context) => {
          if (!value) return;

          const error = validateBirthDate(value);
          if (error) context.addIssue({ code: z.ZodIssueCode.custom, message: t(`addProfileForm.errors.${error}`) });
        }),
    })
  );

  const { errors, defineField, handleSubmit } = useForm({ validationSchema, initialValues: { name: '', dateOfBirth: '' } });

  const [name] = defineField('name');
  const [dateOfBirth] = defineField('dateOfBirth');

  const updateDateOfBirth = (event) => {
    const formatted = formatBirthDateInput(event.target.value);

    event.target.value = formatted;
    dateOfBirth.value = formatted;
  };

  const closeForm = () => store.commit('handleAddProfile', false);

  const submit = handleSubmit((values) => {
    store.dispatch(actionTypes.createProfile, {
      name: values.name,
      avatar: DEFAULT_PROFILE_AVATAR,
      date_of_birth: toApiBirthDate(parseBirthDate(values.dateOfBirth)),
    });
    closeForm();
    router.push('/ProfilesGate');
  });

  return { name, dateOfBirth, errors, updateDateOfBirth, submit, closeForm };
};
